import type { MailboxInfo } from 'owa-client-types';
import type { ApplicationSettingGroup, ApplicationSettings } from 'owa-application-settings';
import { type B2ServiceApiMode } from './B2ServiceApiMode';
import { getAPIModeFromConfiguration } from './utils/getAPIModeFromConfiguration';

/**
 * Gets the B2 service API mode configured for a specific action.
 *
 * @param actionName - The action name to check
 * @param getApplicationSettings - Parameter for ApplicationSettings
 * @param mailboxInfo - Optional mailbox info for multi-account scenarios
 * @returns The B2ServiceApiMode (Shadow, Comparison, Fallback, or Disabled if not configured)
 */
export function getB2ServiceApiMode(
    actionName: string,
    getApplicationSettings?: <TGroup extends ApplicationSettingGroup>(
        group: TGroup,
        mailboxInfo?: MailboxInfo,
        dontErrorIfNotInitialized?: boolean
    ) => ApplicationSettings[TGroup],
    mailboxInfo?: MailboxInfo
): B2ServiceApiMode {
    try {
        // Check if ApplicationSettings for B2Service is present
        const settings = getApplicationSettings?.(
            'B2Service',
            mailboxInfo,
            true /* dontErrorIfNotInitialized */
        );

        return getAPIModeFromConfiguration(settings, actionName);
    } catch {
        // Fallback to safe default on any error (e.g., localStorage access issues, JSON parse errors)
    }
    return 0;
}
